import get from 'lodash.get';

const getPartnerUpgradeUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.upgradeUrl', null);

export default getPartnerUpgradeUrl;
